import { Para } from '@drycut/ui-components';

type Props = {
  couponExpiration: null | string;
};

export default function ExpirationDate({ couponExpiration, ...props }: Props): React.ReactNode {
  if (!couponExpiration) {
    return null;
  }

  return (
    <Para size="sm" align="center" {...props} className="text-zinc-400">
      Die Aktion ist gültig bis: {new Date(couponExpiration).toLocaleDateString()}
    </Para>
  );
}
